<style>
#addServitudeModal .v--modal-box.v--modal {
  min-height: 410px !important;
  min-width: 460px !important;
}
#addServitudeModal .v-subheader {
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 600 !important;
}
#addServitudeModal .v-tabs__div:not(:last-child) {
  padding-right: 5px;
}
#addServitudeModal .v-tabs__div {
  background-image: linear-gradient(
      to bottom,
      rgba(42, 87, 154, 1) 0%,
      rgba(42, 87, 154, 1) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  background-clip: content-box, padding-box;
}
</style>

<template>
  <Modal
    modalName="addServitudeModal"
    title="DODAJ SŁUŻEBNOŚĆ"
    :buttons="['save']"
    @saved="save"
    @opened="loadDict"
    @closed="close"
  >
    <v-tabs
      color="#2a579a"
      dark
      centered
      grow
      active-class="tab--active"
      :hide-slider="true"
      height="35"
    >
      <v-tab>ATRYBUTY</v-tab>
      <v-tab-item>
        <v-card
          flat
          id="attr__wrapper"
        >
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            >
              <v-layout
                row
                wrap
              >
                <v-flex xs12>
                  <v-subheader>PODSTAWOWE INFORMACJE O SŁUŻEBNOŚCI</v-subheader>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex xs5>
                  <v-select
                    :items="statuses"
                    v-model="transmisionData.status"
                    label="Status"
                    required
                    :rules="required"
                  ></v-select>
                </v-flex>
                <v-spacer />
                <v-flex xs5>
                  <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="computedDateFormatted"
                        label="Data ustanowienia"
                        prepend-icon="event"
                        @input="transmisionData.date = parseDate(computedDateFormatted)"
                        v-on="on"
                        required
                        :rules="required"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="transmisionData.date"
                      @input="dateMenu = false"
                      color="#2a579a"
                      no-title
                      required
                      :rules="required"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex xs5>
                  <v-text-field
                    label="Numer księgi wieczystej"
                    v-model="transmisionData.register_number"
                    required
                    :rules="required"
                  ></v-text-field>
                </v-flex>
                <v-spacer />
                <v-flex xs5>
                  <v-text-field
                    label="Numer repertorium"
                    v-model="transmisionData.repertory_number"
                    required
                    :rules="required"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex xs5>
                  <v-text-field
                    label="Szerokość pasa gruntu obciążonego służebnością"
                    v-model="transmisionData.width"
                    type="number"
                    required
                    :rules="required"
                  ></v-text-field>
                </v-flex>
                <v-spacer />
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex xs12>
                  <v-subheader>INFORMACJE O LOKALIZACJI</v-subheader>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex xs5>
                  <v-text-field
                    label="Adres"
                    v-model="transmisionData.parcel_address"
                  ></v-text-field>
                </v-flex>
                <v-spacer />
                <v-flex xs5>
                  <v-text-field
                    label="Numer działki"
                    v-model="transmisionData.nr_dzialka"
                    :disabled="true"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex xs5>
                  <v-text-field
                    label="Obręb"
                    v-model="transmisionData.precinct_name"
                    :disabled="true"
                  ></v-text-field>
                </v-flex>
                <v-spacer />
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex xs12>
                  <v-subheader>INFORMACJE O WŁAŚCICIELU</v-subheader>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex xs5>
                  <v-text-field
                    label="Adres"
                    v-model="transmisionData.address"
                    required
                    :rules="required"
                  ></v-text-field>
                </v-flex>
                <v-spacer />
                <v-flex xs5>
                  <v-select
                    :items="ownerTypes"
                    v-model="transmisionData.owner_type"
                    label="Typ właściciela"
                    required
                    :rules="required"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex xs5>
                  <v-text-field
                    label="Kontakt"
                    v-model="transmisionData.contact"
                    required
                    :rules="required"
                  ></v-text-field>
                </v-flex>
                <v-spacer />
                <v-flex xs5>
                  <v-text-field
                    label="Właściciel"
                    v-model="transmisionData.owner"
                    required
                    :rules="required"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex xs12>
                  <v-text-field
                    label="Opis"
                    v-model="transmisionData.description"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
        </v-card>
      </v-tab-item>

      <v-tab>POWIĄZANE OBIEKTY</v-tab>
      <v-tab-item>
        <v-layout
          row
          wrap
        >
          <v-flex xs12>
            <v-subheader>DODAWANIE OBIEKTÓW</v-subheader>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex xs12>
            <v-btn
              small
              dark
              depressed
              color="#2a579a"
              style="margin-left: 0;"
              @click="selectNewObject"
            >WSKAŻ OBIEKT NA MAPIE</v-btn>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-list
            subheader
            style="width: 100%"
            v-if="objects.length != 0"
          >
            <v-subheader>POWIĄZANE ELEMENTY</v-subheader>
            <v-list-tile
              v-for="(object, index) in objects"
              :item="object"
              :key="object.object_id"
              style="border-bottom: 1px solid lightgrey"
            >
              <v-list-tile-content>
                <v-list-tile-title class="font--primary">Obiekt '{{object.full_name}}' - {{object.object_display_id}}</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <span>
                  <v-icon
                    depressed
                    fab
                    id="btn__hydrant--zoom"
                    class="hydrant__icon"
                    @click="zoomToObject(object, index)"
                    title="Przybliż do obiektu"
                  >zoom_in</v-icon>
                  <v-icon
                    depressed
                    fab
                    class="hydrant__icon"
                    id="btn__hydrant--remove"
                    @click="removeObject(object, index)"
                    title="Usuń obiekt"
                  >delete</v-icon>
                </span>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <v-flex v-else>
            <v-subheader>POWIĄZANE ELEMENTY</v-subheader>
            <p
              v-if="objects.length == 0"
              style="font-size: 12px; margin-bottom:20px"
            >Brak zaznaczonych obiektów. Kliknij przycisk powyżej, a następnie wskaż na mapie obiekt, do którego chciałbyś dodać załącznik.</p>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex xs12>
            <v-subheader>DŁUGOŚĆ I POWIERZCHNIA POWIĄZANYCH ELEMENTÓW</v-subheader>
          </v-flex>
          <v-flex
            xs12
            v-if="objects.length == 0"
          >
            <p>Brak powiązanych elementów</p>
          </v-flex>
          <template v-else>
            <v-flex xs12>
              <p v-for="(length, table) in lengthSum">
                <span v-if="table == 'pipes'">Sumaryczna długość przewodów wodociągowych: {{length.toFixed(2)}} m</span>
                <span v-else-if="table == 'pipes_sewers'">Sumaryczna długość przewodów kanalizacyjnych: {{length.toFixed(2)}} m</span>
              </p>
            </v-flex>
            <v-flex xs12>
              <p>Powierzchnia części nieruchomości obciążona służebnością przesyłu: {{areaSum.toFixed(2)}} m<sup>2</sup></p>
            </v-flex>
          </template>
        </v-layout>
      </v-tab-item>
      
      <!-- No events during adding insepction - that's why (0) -->
      <v-tab>ZDARZENIA (0)</v-tab>
      <v-tab-item>
        <v-card flat>
          <v-card-text class="msg--no-data">Brak dostępnych zdarzeń</v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab>ZAŁĄCZNIKI (0)</v-tab>
      <v-tab-item>
        <v-card flat>
          <v-card-text class="msg--no-data">Dodawanie załączników jest dostępne po zapisie służebności</v-card-text>
          <!-- <AddAttachment
              ref="videoInspectAttach"
              @confDialogOpened="triggerDialogAttach"
              :id_="oid"
              :objectType="objectType"
              :objectTable="objectTable"
              :auto="false"
              :module="module"
            /> -->
        </v-card>
      </v-tab-item>

    </v-tabs>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

import {getArea, getLength} from "ol/sphere.js";
import {
  LineString,
  Polygon,
  MultiPoint,
  MultiPolygon,
  MultiLineString,
  Point
} from "ol/geom";
import LinearRing from "ol/geom/LinearRing";
import GeometryCollection from "ol/geom/GeometryCollection";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import includes from "lodash/includes";
import map from "lodash/map";
import each from "lodash/each";
import some from "lodash/some";
import find from "lodash/find";
import filter from "lodash/filter";
import sumBy from "lodash/sumBy";
import clone from "lodash/clone";
import defaults from "lodash/defaults";
import groupBy from "lodash/groupBy";
import mapValues from "lodash/mapValues";
mixin(_, {
  includes,
  map,
  some,
  find,
  each,
  filter,
  chain,
  sumBy,
  clone,
  defaults,
  groupBy,
  mapValues
});
_.value = value;
_.prototype.value = value;


import OL3Parser from "jsts/org/locationtech/jts/io/OL3Parser";
import {
  Coordinate,
  Geometry as jstsGeometry,
  GeometryFactory
} from "jsts/org/locationtech/jts/geom";
import {BufferOp} from "jsts/org/locationtech/jts/operation/buffer";
import {RelateOp} from "jsts/org/locationtech/jts/operation/relate";
import {OverlayOp} from "jsts/org/locationtech/jts/operation/overlay";

//<editor-fold defaultstate="collapsed" desc="config jsts geometry">
const ol_parser = new OL3Parser();
ol_parser.inject(
  Point,
  LineString,
  LinearRing,
  Polygon,
  MultiPoint,
  MultiLineString,
  MultiPolygon,
  GeometryCollection
);
jstsGeometry.prototype.buffer = function () {
  return BufferOp.bufferOp(this, ...arguments);
};
jstsGeometry.prototype.intersects = function () {
  return RelateOp.intersects(this, ...arguments);
};
jstsGeometry.prototype.contains = function () {
  return RelateOp.contains(this, ...arguments);
};
jstsGeometry.prototype.intersection = function (other) {
  return OverlayOp.intersection(this, other);
};

const fabryka = new GeometryFactory();
//</editor-fold>

export default {
  components: {
    Modal
  },
  data: () => ({
    // RULES
    valid: false,
    required: [v => !!v || "Pole wymagane"],
    
    connectedElements: [],
    dateMenu: false,
    objects: [],
    
    //słownki
    statuses: [],
    ownerTypes: [],
    
    transmisionData: {
      date: new Date().toISOString().substr(0, 10),
      parcel: undefined,
      precinct_name: undefined,
    },
    dzialka: undefined
  }),
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.transmisionData.date.slice(0, 10))
    },
    map() {
      return this.$store.getters.getMap;
    },
    geoportalName() {
      return this.$store.getters.getAquagisName;
    },
    areaSum() {
      return _.sumBy(this.objects, (object) => object.length * 2); // Domyślna szerokość służebności - 2m
    },
    lengthSum() {
      return _(this.objects)
        .groupBy('object_table')
        .mapValues((objects, object_table) => _.sumBy(objects, 'length'))
        .value();
    },
    selectedLayer() {
      return this.map
        .getLayers()
        .item(3)
        .getLayers()
        .item(0);
    },
  },
  watch: {
    'transmisionData.date'(val) {
      this.date = this.formatDate(this.transmisionData.date);
    },
    objects(_new) {
      this._computedWatchers.areaSum.update();
      this._computedWatchers.lengthSum.update();
      this.$forceUpdate();
    }
  },
  methods: {
    close() {
      this.$root.$emit('toggleLayer', `app_layer_${this.geoportalName}:granice_dzialek`, false);
      this.map.getViewport().style.cursor = "";
      this.$root.$emit("clearSelectionFeatures");
      this.$root.$emit("disableSelectionElement");
      this.objects = [];
      
      this.transmisionData = {
        date: new Date().toISOString().substr(0, 10),
        parcel: undefined,
        precinct_name: undefined,
      };
    },
    save() {
      const self = this;
      
      const payload = _.clone(self.transmisionData);
      payload.objects = _.map(self.objects, (object) => ({
        object_id: object.object_id,
        object_table: object.object_table,
        object_type: "layers",
        area: object.length * 2,
        length: object.length,
      }));

      delete payload.nr_dzialka;
      delete payload.nr_obreb;
      
      if(this.$refs.form.validate()) {
        fetch(`${self.$store.getters.getApiURL}/transmision-easement?token=${self.$store.getters.getToken}`, {
          method: 'POST',
          body: JSON.stringify(payload)
        })
          .then(response =>
            response.status === 200
              ? response.json().then((data) => [response.status, data])
              : response.text().then((data) => [response.status, data])
          )
          .then(([status, data]) => {
            if(status === 200) {
              self.$root.$emit("showSnackbar", "success", "Dodano");
            } else {
              self.$root.$emit("showSnackbar", "orange", data);
            }
          })
          .catch(error => {
            self.$root.$emit("showSnackbar", "red", error);
          });
      }
    },
    
    formatDate(date) {
      if(!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if(!date) return null;

      const [day, month, year] = date.split('-');
      return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`;
    },
    
    loadDict() {
      const payload = {
        schema: "registry",
        table: "transmission_easement"
      };
      this.$store.dispatch('getDictSTC', _.defaults({
        column: "status"
      }, payload)).then(r => {
        this.statuses = r.values;
      });
      this.$store.dispatch('getDictSTC',  _.defaults({
        column: "owner_type"
      }, payload)).then(r => {
        this.ownerTypes = r.values;
      });
    },

    selectNewObject() {
      const self = this;

      self.$root.$emit(
        "showSnackbar",
        "#2a579a",
        "Kliknij na mapie, aby wybrać obiekt"
      );
      self.map.getViewport().style.cursor = "crosshair";
      const geomDzialka = ol_parser.read(self.dzialka.getGeometry());

      self.$root.$once("selectionElementCallback", featuresLayers => {
        //console.log(featuresLayers);
        _.each(featuresLayers, featuresLayer => {
          //przeleć po warstwach
          const features = featuresLayer.features_cluster.length > 0
            ? featuresLayer.features_cluster
            : featuresLayer.features;
          _.each(features, feature => {
            //przeleć po elementach warstwy
            const id = feature.getId();

            if(_.some(self.objects, object => object.object_id === id)) {
              return; //duplicat
            }

            const geomObject = ol_parser.read(feature.getGeometry());
            if(geomObject.intersects(geomDzialka)) {
              const geom = ol_parser.write(geomObject.intersection(geomDzialka));
              const org_feature = self.$root.createProxy(feature);

              self.objects.push({
                object_id: feature.getId(),
                object_table: featuresLayer.layer.get("type"),
                object_type: "layers",
                full_name: featuresLayer.layer.get("full_name"),
                object_display_id: feature.getId(),

                length : getLength(geom),
                org_feature, //orginalny feature do usuwania i zoomu
              });

              self.$store.commit("addCurrentSelectedFeatures", [org_feature]); //dodanie do listy zaznaczonych
              self.selectedLayer.getSource().addFeature(feature); //dodanie podświetlania
            } else {
              self.$root.$emit(
                "showSnackbar",
                "orange",
                "Obiekt poza działką"
              );
            }
          });
        });
        self.$forceUpdate();
        self.map.getViewport().style.cursor = "";
      });
      self.$root.$emit("enableSelectionElement", {
        layers: ["pipes", "pipes_sewers"],
        selected: false,
        multi: false
      });
    },
    removeObject(object, index) {
      this.objects.splice(index, 1);
      
      this.$store.commit("removeCurrentSelectedFeatures", [object.org_feature]); //usunięcie z listy zaznaczonych
      this.selectedLayer.getSource().removeFeature(object.org_feature.__value); //usunięcie podświetlania
    },
    zoomToObject(object, index) {
      this.$root.$emit("zoomToFeature", object.org_feature.__value, {});
    },
    
    setPlotFeature(data) {
      this.transmisionData.nr_dzialka = data.get('nr_dzialka');
      this.transmisionData.precinct_name = data.get('nazwa_obre');
      this.transmisionData.nr_obreb = data.get('nr_obreb');
      this.transmisionData.parcel = data.get('teryt');
      this.dzialka = data;
    }
  },
  mounted() {
    this.$root.$on('setPlotFeature', this.setPlotFeature);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/servitude/modals/AddServitudeModal.vue